/* GGEMA — Aura Reading quiz (theme port, vanilla JS, no dependencies) */
(function(){
  'use strict';
  var root = document.querySelector('.gg-aura');
  if(!root) return;
  var cfgEl = document.getElementById('aq-config');
  if(!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  var GEMS = {ruby:'#b01e3c',sapphire:'#24418f',emerald:'#0f6b4f',gold:'#c9a24b',moonstone:'#ede8de',rose:'#e3aebb',ambre:'#8a5a33'};
  var CARDS = CFG.cards, AURAS = CFG.auras, T = CFG.t;
  var ORDER = ['BOLD','MAGNETIC','GROUNDED','CONFIDENT','RADIANT','SOFT'];
  var scores = {BOLD:0,MAGNETIC:0,GROUNDED:0,CONFIDENT:0,RADIANT:0,SOFT:0};
  var likedGems = [], idx = 0, sillage = null, prenom = '', genre = 'libre', emailSent = false, finalAura = null, finalPick = null;

  function track(ev, data){
    try{
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({event:ev}, data||{}));
      if(typeof window.fbq === 'function') window.fbq('trackCustom', ev, data||{});
    }catch(e){}
  }
  function $(s){return root.querySelector(s);}
  function $all(s){return root.querySelectorAll(s);}
  function go(id){ $all('.aq-screen').forEach(function(s){s.classList.toggle('active', s.id===id);}); }

  /* ---- living background ---- */
  function hexToRgb(h){var n=parseInt(h.slice(1),16);return [n>>16&255,n>>8&255,n&255];}
  function mixGems(){
    if(!likedGems.length) return null;
    var last = likedGems.slice(-4), r=0,g=0,b=0;
    last.forEach(function(k){var v=hexToRgb(GEMS[k]||GEMS.ruby); r+=v[0]; g+=v[1]; b+=v[2];});
    return 'rgb('+Math.round(r/last.length)+','+Math.round(g/last.length)+','+Math.round(b/last.length)+')';
  }
  function updateAuraBg(){
    var c = mixGems(); if(!c) return;
    $('.aq-bg').style.background =
      'radial-gradient(130% 95% at 50% 112%, '+c.replace('rgb','rgba').replace(')',',.42)')+', transparent 62%),'+
      'radial-gradient(90% 60% at 50% -15%, '+c.replace('rgb','rgba').replace(')',',.14)')+', transparent 60%),'+
      'var(--nuit)';
  }

  /* ---- deck ---- */
  var deckEl = $('.aq-deck'), progEl = $('.aq-progress i'), countEl = $('#aq-count');
  function sceneHtml(c, first){
    if(c.img){
      return '<img src="'+c.img+'" srcset="'+c.imgset+'" sizes="(min-width:480px) 432px, calc(100vw - 48px)" alt="" '+(first?'':'loading="lazy" ')+'width="'+(c.imgw||800)+'" height="'+(c.imgh||1000)+'">';
    }
    return '';
  }
  function buildDeck(){
    deckEl.innerHTML='';
    CARDS.forEach(function(c,i){
      var el=document.createElement('figure');
      el.className='aq-card';
      el.dataset.i=i;
      el.innerHTML='<div class="aq-scene" style="background:'+c.scene+'">'+sceneHtml(c, i===0)+'</div>'+
        '<span class="aq-stamp yes">'+T.yes+'</span>'+
        '<span class="aq-stamp no">'+T.no+'</span>'+
        '<figcaption>'+c.cap+'</figcaption>';
      stackStyle(el, i-idx);
      deckEl.appendChild(el);
      attachDrag(el);
    });
  }
  function stackStyle(el, depth){
    if(depth<0){el.style.display='none';return;}
    el.style.display='flex';
    el.style.zIndex = 100-depth;
    var d=Math.min(depth,2);
    el.style.transform='translateY('+(d*10)+'px) scale('+(1-d*0.035)+')';
    el.style.opacity = depth>2 ? 0 : 1;
  }
  function refreshStack(){
    Array.prototype.forEach.call(deckEl.children, function(el){stackStyle(el, +el.dataset.i - idx);});
    progEl.style.width = (idx/CARDS.length*100)+'%';
    countEl.textContent = Math.min(idx+1,CARDS.length)+' / '+CARDS.length;
  }
  function topCard(){ return deckEl.querySelector('.aq-card[data-i="'+idx+'"]'); }
  function decide(liked){
    var card = topCard(); if(!card) return;
    var data = CARDS[idx];
    if(liked){
      Object.keys(data.w).forEach(function(k){scores[k]+=data.w[k];});
      likedGems.push(data.gem);
      updateAuraBg();
    }
    track('aura_quiz_card', {index: idx, direction: liked?'right':'left'});
    var off = liked? 1 : -1;
    card.style.transition='transform .45s ease, opacity .45s ease';
    card.style.transform='translateX('+(off*130)+'%) rotate('+(off*22)+'deg)';
    card.style.opacity=0;
    idx++;
    setTimeout(function(){card.style.display='none'; refreshStack();},380);
    if(idx>=CARDS.length){ setTimeout(function(){go('aq-sillage');}, 620); }
  }
  function attachDrag(el){
    var sx=0, sy=0, dx=0, dragging=false;
    var yes=el.querySelector('.aq-stamp.yes'), no=el.querySelector('.aq-stamp.no');
    el.addEventListener('pointerdown', function(e){
      if(+el.dataset.i!==idx) return;
      dragging=true; sx=e.clientX; sy=e.clientY;
      el.classList.add('dragging');
      el.setPointerCapture(e.pointerId);
    });
    el.addEventListener('pointermove', function(e){
      if(!dragging) return;
      dx=e.clientX-sx; var dy=e.clientY-sy;
      el.style.transform='translate('+dx+'px,'+(dy*0.4)+'px) rotate('+(dx/16)+'deg)';
      yes.style.opacity=Math.min(Math.max(dx/80,0),1);
      no.style.opacity=Math.min(Math.max(-dx/80,0),1);
    });
    var end=function(){
      if(!dragging) return; dragging=false;
      el.classList.remove('dragging');
      yes.style.opacity=0; no.style.opacity=0;
      if(dx>90){decide(true);}
      else if(dx<-90){decide(false);}
      else{el.style.transition='transform .3s ease'; el.style.transform=''; setTimeout(refreshStack,300);}
      dx=0;
    };
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
  }
  $('.aq-yes').addEventListener('click',function(){decide(true);});
  $('.aq-no').addEventListener('click',function(){decide(false);});
  window.addEventListener('keydown',function(e){
    if(!$('#aq-deck-screen').classList.contains('active'))return;
    if(e.key==='ArrowRight')decide(true);
    if(e.key==='ArrowLeft')decide(false);
  });

  /* ---- flow ---- */
  $('#aq-start').addEventListener('click',function(){
    go('aq-genre');
    track('aura_quiz_start');
  });
  $all('.aq-genre-choice').forEach(function(b){b.addEventListener('click',function(){
    genre=b.dataset.genre;
    buildDeck(); refreshStack(); go('aq-deck-screen');
    track('aura_quiz_genre',{genre:genre});
  });});
  $all('.aq-sillage-choice').forEach(function(b){b.addEventListener('click',function(){
    sillage=b.dataset.sillage;
    if(CFG.emailCapture){ go('aq-email'); } else { showResult(); }
  });});
  var revealBtn = $('#aq-reveal'), skipBtn = $('#aq-skip');
  if(revealBtn) revealBtn.addEventListener('click',function(){
    prenom=($('#aq-name').value||'').trim();
    var email=($('#aq-email-field').value||'').trim();
    if(email){ sendKlaviyo(email); }
    showResult();
  });
  if(skipBtn) skipBtn.addEventListener('click', function(){ showResult(); });
  $('#aq-restart').addEventListener('click',function(){location.reload();});

  function computeAura(){
    var best=ORDER[0];
    ORDER.forEach(function(k){ if(scores[k]>scores[best]) best=k; });
    if(scores[best]===0) best='SOFT';
    return best;
  }
  function sendKlaviyo(email){
    if(!CFG.klaviyo) return;
    var key = computeAura(), a = AURAS[key];
    var payload={data:{type:'subscription',attributes:{profile:{data:{type:'profile',attributes:{
      email:email, first_name: prenom||undefined,
      properties:{aura:'AURA '+a.nom, intention:key, gemme:a.gem, sillage:sillage||'', genre:genre, source:'aura-quiz'}
    }}}},relationships: CFG.klaviyoList?{list:{data:{type:'list',id:CFG.klaviyoList}}}:undefined}};
    try{
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(CFG.klaviyo),{
        method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},
        body:JSON.stringify(payload)
      }).then(function(r){ if(r.ok){ emailSent=true; track('aura_quiz_email_submitted',{aura:key}); } else { console.error('aura-quiz: klaviyo '+r.status); } })
      .catch(function(e){ console.error('aura-quiz: klaviyo', e); });
    }catch(e){ console.error('aura-quiz: klaviyo', e); }
  }
  function matchHtml(eyebrow, p, priceLine){
    return (p.img?'<div class="aq-match-img"><img src="'+p.img+'" alt="'+p.title+'" loading="lazy" width="86" height="108"></div>':'')+
      '<div class="aq-match-body"><div class="aq-eyebrow">'+eyebrow+'</div><h3>'+p.title+'</h3><p>'+(p.notes||'')+'</p>'+
      (priceLine?'<div class="aq-price">'+priceLine+'</div>':'')+
      '<span class="aq-match-cta">'+T.discover+'</span></div>';
  }
  function showResult(){
    var key = computeAura(); finalAura = key;
    var a=AURAS[key], c=GEMS[a.gem];
    var pick = (genre==='elle' ? a.elle : a.lui).slice();
    var BS = (CFG.bestsellers||[]).map(function(s){return s.trim().toUpperCase();});
    var isBS = function(p){return BS.indexOf((p.title||'').toUpperCase())>-1;};
    if(pick.length && !isBS(pick[0])){
      for(var bi=1; bi<pick.length; bi++){ if(isBS(pick[bi])){ pick.unshift(pick.splice(bi,1)[0]); break; } }
    }
    var starT=(CFG.star&&CFG.star.title||'').toUpperCase();
    var hasStar=pick.some(function(p){return (p.title||'').toUpperCase()===starT;});
    if(!hasStar && CFG.star){ pick[2]=CFG.star; }
    finalPick = pick;
    var dark = a.gem==='moonstone';
    var cardEl=$('#aq-auracard');
    cardEl.style.background='linear-gradient(165deg, '+c+' 0%, #131019 130%)';
    cardEl.style.color = dark ? '#1c1a17' : 'var(--ink)';
    var orb=$('#aq-aorb');
    orb.style.background='radial-gradient(circle at 32% 28%, #ffffffcc, '+c+' 45%, #131019 105%)';
    orb.style.boxShadow='0 0 70px 8px '+c+'66';
    $('#aq-aname').textContent='AURA '+a.nom;
    $('#aq-aintent').textContent=key;
    $('#aq-atag').textContent='« '+a.tag+' »';
    $('#aq-afor').textContent=(prenom? T.read_for+' '+prenom.toUpperCase()+' · ' : '')+'GGEMA PARIS';
    var fmt = T['format_'+(sillage||'discret')] || T.format_discret;
    var bsTag=function(p){return isBS(p)?' · '+T.bestseller_tag:'';};
    var main=$('#aq-match-main');
    main.innerHTML=matchHtml(T.your_scent+bsTag(pick[0]), pick[0], (pick[0].price? T.from+' '+pick[0].price+' · ' : '')+fmt);
    main.href=pick[0].url||'#';
    var alt=$('#aq-match-alt');
    alt.innerHTML=matchHtml(T.other_facet+bsTag(pick[1]), pick[1]);
    alt.href=pick[1].url||'#';
    var starEl=$('#aq-match-star');
    if(pick[2]){
      var starLabel=((pick[2].title||'').toUpperCase()===starT) ? T.house_essential : T.go_further;
      starEl.hidden=false;
      starEl.innerHTML=matchHtml(starLabel+bsTag(pick[2]), pick[2]);
      starEl.href=pick[2].url||'#';
    } else { starEl.hidden=true; }
    track('aura_quiz_complete',{aura:key, sillage:sillage||'', genre:genre});
    go('aq-result');
  }

  /* ---- shareable canvas card 1080x1920 ---- */
  $('#aq-download').addEventListener('click',function(){
    var key = finalAura||computeAura();
    var a=AURAS[key], c=GEMS[a.gem];
    var pick = finalPick||(genre==='elle'?a.elle:a.lui);
    var pmain = pick[0]||pick.main||{title:'Ggema'};
    var cv=document.createElement('canvas'); cv.width=1080; cv.height=1920;
    var x=cv.getContext('2d');
    var g=x.createLinearGradient(0,0,300,1920);
    g.addColorStop(0,c); g.addColorStop(1,'#0a090c');
    x.fillStyle=g; x.fillRect(0,0,1080,1920);
    var halo=x.createRadialGradient(540,640,60,540,640,420);
    halo.addColorStop(0,'rgba(255,255,255,.55)');
    halo.addColorStop(.45,c); halo.addColorStop(1,'rgba(10,9,12,0)');
    x.fillStyle=halo; x.beginPath(); x.arc(540,640,420,0,7); x.fill();
    var dark = a.gem==='moonstone';
    x.fillStyle = dark? '#1c1a17' : '#f2efe9';
    x.textAlign='center';
    var serif=CFG.serif||'Georgia, serif', sans=CFG.sans||'Helvetica, sans-serif';
    x.font='500 44px '+sans;
    x.fillText('G G E M A   P A R I S',540,180);
    x.font='600 130px '+serif;
    x.fillText('AURA '+a.nom,540,1180);
    x.font='500 52px '+sans;
    x.fillText(key.split('').join(' '),540,1270);
    x.font='italic 500 56px '+serif;
    wrap(x,'« '+a.tag+' »',540,1400,860,72);
    x.font='400 40px '+sans;
    x.globalAlpha=.85;
    x.fillText((prenom? prenom.toUpperCase()+' · ':'')+pmain.title.toUpperCase(),540,1700);
    x.fillText('ggema.com',540,1790);
    x.globalAlpha=1;
    var link=document.createElement('a');
    link.download='mon-aura-ggema.png';
    link.href=cv.toDataURL('image/png');
    link.click();
    track('aura_quiz_share_downloaded',{aura:key});
  });
  function wrap(x,t,cx,cy,maxW,lh){
    var words=t.split(' '), line='', lines=[];
    words.forEach(function(w){
      if(x.measureText(line+w).width>maxW){lines.push(line);line=w+' ';}
      else line+=w+' ';
    });
    lines.push(line);
    lines.forEach(function(l,i){x.fillText(l.trim(),cx,cy+i*lh);});
  }
})();
